import { render } from "./table-cell-number.vue?vue&type=template&id=32f25411"
import script from "./table-cell-number.vue?vue&type=script&lang=js"
export * from "./table-cell-number.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__